/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDaw: {
  name: 'arrow-daw';
  data: string;
} = {
  name: 'arrow-daw',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.555 5.168a1 1 0 0 1 .277 1.387l-8 12a1 1 0 0 1-1.6.085L4 8.762V11a1 1 0 1 1-2 0V6a1 1 0 0 1 1.196-.98l5 1a1 1 0 0 1-.392 1.96l-2.222-.444 7.329 8.795 7.257-10.886a1 1 0 0 1 1.387-.277Z" fill="currentColor"/></svg>`,
};
